<template>
  <div>
    <paywall-upgrade-dialog
      v-if="upgradeDialog"
      :plans="plans"
      @close="upgradeDialog=false"
    />
    <v-badge
      v-if="!unlocked"
      class="paywall-badge"
      hidden
      overlap
      icon="mdi-lock"
      :color="badgeColor"
    >
      <v-btn
        v-bind="$attrs"
        :disabled="disabled"
        @click="click($event)"
      >
        <slot />
      </v-btn>
    </v-badge>
    <v-btn
      v-else
      v-bind="$attrs"
      :disabled="disabled"
      @click="click($event)"
    >
      <slot />
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType, ref } from 'vue';
import PaywallUpgradeDialog from '@/components/dialogs/PaywallUpgradeDialog.vue';
import { useVuetify } from '../helpers/vue2-helpers';

const vuetify = useVuetify();

const props = defineProps({
  unlocked: { type: Boolean, required: true },
  disabled: { type: Boolean, required: false, default: false },
  plans: { type: Array as PropType<('pro' | 'business' | 'ultimate')[]>, required: false, default: () => undefined },
});

const emit = defineEmits(['click']);

const upgradeDialog = ref(false);

const click = (event: any) => {
  if (props.unlocked) {
    emit('click', event);
    return;
  }
  upgradeDialog.value = true;
};

const badgeColor = computed(() => {
  if (!props.disabled) return 'red';
  if (vuetify.theme.dark) return 'grey darken-3';
  return 'grey lighten-1';
});

</script>

<style lang="scss">
.paywall-badge .v-badge__badge .v-icon {
  padding-bottom: 2px;
}
</style>
